import Dexie from 'dexie'

var db = new Dexie("AppConfig");
db.version(1).stores({
    config: "++id,name,value"
});

window.dexie = db